import { useTasksKanbanStore } from '@stores/tasks-kanban'

import { useKanbanTaskShowApi } from '@api/tasks-kanban/kanban-task-show.hook'
import { useTasksKanbanAgentsApi } from '@api/tasks-kanban/agents.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const id = to.params.id
  const tasksKanbanStore = useTasksKanbanStore()

  if (typeof id !== 'string' || !id) return

  tasksKanbanStore.clearTaskDetail()

  void useKanbanTaskShowApi({ id })
  void useTasksKanbanAgentsApi()
})
